import React, { useState } from "react";
import styles from "./ManageAISettingsForm.module.scss";
import { withTranslation } from "react-i18next";
import Card from "components/Card";
import Input from "components/Input";
import { testNumberRegexCheck } from "utils";
import { cloneDeep } from "lodash";
import { updateOwnerAiSettings } from "repositories/ai-assistant-repository";
import toast from "react-hot-toast";
import Loader from "components/Loader";

function ManageAISettingsForm({
  t,
  aiTokens,
  aiTokensUsed,
  isAiSettingsEnabled,
  accountOwnerId,
  goBack,
}) {
  const [formData, setFormData] = useState({
    assignToken: aiTokens,
  });
  const [errors, setErrors] = useState({});
  const [showLoader, setshowLoader] = useState(false);

  const handleAssignTokenChange = (e) => {
    if (testNumberRegexCheck(e.target.value)) {
      setFormData({
        ...formData,
        assignToken: e.target.value,
      });
    }
  };

  const isValidEvent = () => {
    const errorsData = cloneDeep(errors);

    const assignTokenValue = formData?.assignToken || "";
    if (!assignTokenValue.toString().trim().length) {
      errorsData.assignToken = t("form.errors.emptyField", {
        field: t("aiAssistant.manageAISettings.assignToken"),
      });
    } else {
      delete errorsData.assignToken;
    }

    setErrors(errorsData);
    return !Object.values(errorsData).some((err) => !!err);
  };

  const handleOwnerAiSetting = async () => {
    if (!isValidEvent()) return;
    setshowLoader(true);
    try {
      const _data = {
        IsAiSettingsEnabled: isAiSettingsEnabled,
        Tokens: +formData?.assignToken || 0,
        OwnerId: +accountOwnerId,
      };

      const resp = await updateOwnerAiSettings(_data);
      toast.success(resp?.message);
      goBack();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setshowLoader(false);
    }
  };

  return (
    <>
      {showLoader && <Loader />}
      <div className={styles["new-instruction-messages"]}>
        <Card radius="10px" className={styles["instruction-card"]}>
          <div className={styles["input-wrapper"]}>
            <Input
              Title={t("aiAssistant.manageAISettings.assignToken")}
              Classes="max-w mb-0"
              Type="number"
              Placeholder="Enter"
              Name="assignToken"
              HandleChange={handleAssignTokenChange}
              Error={
                !formData?.assignToken && errors.assignToken
                  ? errors.assignToken
                  : ""
              }
              Value={formData?.assignToken || ""}
            />
            {aiTokens && (
              <span className={styles["character-limit-msg"]}>
                {t("aiAssistant.manageAISettings.tokenUsed")}
                {`${aiTokensUsed || 0}/${aiTokens || 0}`}
              </span>
            )}
          </div>
          <button
            className="button  button-round button-shadow mt-4"
            onClick={() => handleOwnerAiSetting()}
            disabled={showLoader}
          >
            {t("save")}
          </button>
        </Card>
      </div>
    </>
  );
}

export default withTranslation()(ManageAISettingsForm);
